import React from 'react';

const TemplateBody = ({children, className}) => {
    return (
        <div className={["flex-grow bg-gray-100 mt-[53px] p-2", className].join(" ")}>
            {children}
        </div>
    );
};

export default TemplateBody;